import React from "react";
import { connect } from "react-redux";
import { fetchIndexingStatus } from "../../actions/indexing";

import SuccessNotice from "../notice/standard-success";
import WarningNotice from "../notice/standard-warning";
import InfoNotice from "../notice/standard-info";

import "./indexing-status.css";

const TEN_SECONDS = 10000;

class IndexingStatus extends React.Component {
  componentDidMount() {
    this.props.fetchIndexingStatus();
    this.timer = setInterval(() => {
      this.props.fetchIndexingStatus();
    }, TEN_SECONDS);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  renderInfo() {
    const { loading, error, errMsg, lastUpdated } = this.props.indexing;
    if (loading) {
      return <small className="indexing-info">Checking...</small>;
    }
    if (error) {
      return (
        <small className="indexing-info" title={errMsg}>
          Couldn't refresh, retrying shortly
          {lastUpdated ? " (last checked " + lastUpdated + ")" : ""}
        </small>
      );
    }
    if (lastUpdated) {
      return (
        <small className="indexing-info">Last checked {lastUpdated}</small>
      );
    }
    return null;
  }

  renderNotice() {
    const { in_queue, error } = this.props.indexing;
    // No status received yet: if the first check failed, say so calmly,
    // otherwise render nothing until the first response arrives.
    if (in_queue === false) {
      return error ? (
        <InfoNotice msg="Index status is temporarily unavailable" />
      ) : null;
    }
    if (in_queue > 0) {
      return (
        <WarningNotice
          msg={"Index is updating (" + in_queue + " jobs pending)"}
        />
      );
    }
    return <SuccessNotice msg="Index up to date" shouldDisplay={true} />;
  }

  render() {
    const notice = this.renderNotice();
    if (!notice) {
      return null;
    }
    return (
      <div className="indexing-block">
        {notice}
        {this.renderInfo()}
      </div>
    );
  }
}

export default connect(
  nextState => ({ indexing: nextState.indexing }),
  { fetchIndexingStatus }
)(IndexingStatus);
